module.exports = __webpack_public_path__ + "img/i14a.8a4cf854.svg";